<template>
  <div :class="$b()">
    <TypeForm
      :class="$b('typeform')"
      :url="`https://sungod.typeform.com/to/${$route.meta.formId}`"
      :hide-headers="true"
      :hide-footer="true"
      button-text="Contact Us"
    />
  </div>
</template>

<script>
export default defineNuxtComponent({
  name: 'EmbeddedTypeformPage'
})
</script>

<style lang="postcss">
.EmbeddedTypeformPage__typeform {
  height: calc(100vh - 100px);
}
</style>
